export default {"src":"/_next/static/media/Call.6fe63603.svg","height":22,"width":22};